// extracted by mini-css-extract-plugin
export default {"root":"AvatarOption_root__c7s7T","layout-container":"AvatarOption_layout-container__oNiGB","avatarsOption":"AvatarOption_avatarsOption__HiRwR","hiddenRadio":"AvatarOption_hiddenRadio__s1T7S","selected":"AvatarOption_selected__i1baq","checkmark":"AvatarOption_checkmark__VZTEI","label":"AvatarOption_label__18V88"};
    if(module.hot) {
      // 1763464084893
      var cssReload = require("/usr/src/app/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  